import { datadogLogs } from '@datadog/browser-logs';

import env from '@wetransfer/transfer/config/env';
import { isBetaEnv, isLocalEnv } from '@wetransfer/transfer/modules/url';

const getEnv = () => {
  if (isLocalEnv()) {
    return 'development';
  } else if (isBetaEnv()) {
    return 'staging';
  }

  return 'production';
};

export const init = (): void => {
  datadogLogs.init({
    clientToken: 'puba22305094ff3835d5d3de34ddc8f5a91',
    site: 'datadoghq.eu',
    env: getEnv(),
    service: 'transfer-frontend',
    forwardErrorsToLogs: false,
    sampleRate: 100,
    silentMultipleInit: true,
    version: env().NEXT_PUBLIC_REVISION,
  });
  datadogLogs.setGlobalContextProperty('app-origin', 'decoupled');
};

export default init;
